import axios from '../../axios'

/*
 * 图片管理模块
 */

// 保存
export const save = (data) => {
  return axios({
    url: '/imageupload/save',
    method: 'post',
    data
  })
}
// 分页查询
export const findPage = (data) => {
  return axios({
    url: '/imageupload/list',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/modules/image/imageupload.js